import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import LandingPage from "./pages/LandingPage";
import NotFound from "./pages/NotFound";
import { initGA, trackPageView } from "./services/analytics";
import { AdminAuthProvider } from "./hooks/useAdminAuth";
import AdminRoutes from "./pages/admin/AdminRoutes";

const queryClient = new QueryClient();

initGA('G-95QFSETJWN');

const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);
  return null;
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin/*" element={<AdminRoutes />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <Sonner />
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
